<template>
  <div>
    <div id="video-chat-container" v-if="showContainer">
      <div id="video-chat-session">
        <div class="videoDiv">
          <div>
            <button class="btn team-btn" @click="openResearchTeamDiv" v-if="!showResearchTeam">
              <div class="plusDiv">+</div>
              Add Research Team Members
            </button>
          </div>
          <div style="text-align:center">
            <div v-if="showResearchTeam" class="mainResearchTeamDiv ml-40">
              <div class="mb-10">Add Research Team Members</div>
              <div class="researchTeamDiv">
                <div class="membersInnerDiv">
                  <div class="row membersHeader fs-13">
                    <div class="col-6 pt-6 pb-6" style="border-right:2px solid #ffffff;">
                      Name
                    </div>
                    <div class="col-6 pt-6 pb-6">Role</div>
                  </div>
                  <div class="membersList">
                    <div class="row pt-2 pb-2" v-for="(member, index) in teamMembers" :key="index">
                      <div class="col-6">
                        <label class="">
                          <input type="checkbox" v-model="member.invitedInTelehealthVisit" />
                          <span>&nbsp;{{ member.firstName }}&nbsp;{{ member.lastName }}</span>
                        </label>
                      </div>
                      <div class="col-6 fs-12">
                        <span v-if="member.userRole == 'Pi'">Principal Investigator</span>
                        <span v-if="member.userRole == 'SubPi'">Sub-Investigator</span>
                        <span v-if="member.userRole == 'StudyCoordinator'">Study Coordinator</span>
                        <span v-if="member.userRole == 'HomeHealth'">Home Health</span>
                        <span v-if="member.userRole == 'SiteDataLock'">Site - Data Lock</span>
                        <span v-if="member.userRole == 'CallCenter'">Call Center</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="clear-fix"></div>
            </div>
          </div>
          <div>
            <button class="btn mb-20 mt-40 call-btn" @click="initiateVideoCall()">
              Call Now
            </button>
          </div>
          <div><span @click="cancel" class="cursor_pointer">Cancel</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";
export default {
  name: "videoChat",
  data() {
    return {
      sessionId: "",
      apiKey: "",
      token: "",
      tokenResponse: "",
      showContainer: false,
      showResearchTeam: false,
      teamMembers: [],
      participantId: "",
      studyId: "",
      showVideo: false,
      countryId: "",
      deviceRegistrationStatus: "",
      appointmentObject: ""
    };
  },
  computed: { ...mapGetters(["user"]) },
  mounted() {
    //Look for the end call event initiated from the PI
    this.$root.$on("videoCallEnded", () => {
      this.apiKey = "";
      this.sessionId = "";
      this.token = "";
    });

    this.$root.$on("videoCallStarted", data => {
      this.participantId = data.participantId;
      this.studyId = data.studyId;
      this.countryId = data.countryId;
      this.deviceRegistrationStatus = data.deviceRegistrationStatus;
      if (data.appointmentObject) {
        this.appointmentObject = data.appointmentObject;
      }
      if (this.user.userRole == "Interviewer") {
        this.siteId = localStorage.getItem("selectedSite").toString();
      } else {
        this.siteId = this.user.siteIds ? this.user.siteIds[0] : null;
      }
      this.getResearchTeamMembers();
      this.showContainer = true;
    });
  },
  methods: {
    initiateVideoCall() {
      if (this.appointmentObject.type == "scheduled") {
        this.$root.$emit("scheduledVideoCallingInitiated", this.appointmentObject);
        this.showContainer = false;
        this.showResearchTeam = false;
      } else {
        this.showContainer = false;
        this.showResearchTeam = false;
        //Emit an event to show/start the video call component
        //TODO get the PARTICIPANT ID TO  START THE CALL
        this.$root.$emit("videoCallingInitiated", {
          participantId: this.participantId,
          threadID : this.appointmentObject && this.appointmentObject.threadID ? this.appointmentObject.threadID : "",
          countryId: this.countryId,
          id: this.appointmentObject.id,
          studyId: this.studyId,
          deviceRegistrationStatus: this.deviceRegistrationStatus,
          teamMembers: this.teamMembers,
          selectedTeamMembers: _.filter(this.teamMembers, member => member.invitedInTelehealthVisit === true)
        });
      }
    },
    cancel() {
      this.showResearchTeam = false;
      this.showContainer = false;
      this.$root.$emit("videoCallCancelled");
    },
    openResearchTeamDiv() {
      this.showResearchTeam = true;
    },
    getResearchTeamMembers() {
      this.$api.getResearchTeamMembersFact(this.studyId, this.siteId).then(
        response => {
          this.teamMembers = _.filter(response.body, member => member.id !== this.user.id);
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting research team members.");
        }
      );
    }
  }
};
</script>

<style scoped lang="scss">
#video-chat-container {
  position: fixed;
  width: 26%;
  height: 100%;
  background: transparent;
  z-index: 999;
  right: 0;
  top: 0;
}

#video-chat-session {
  background: #000;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 999;
  color: #ffffff;
  overflow: auto;
}

.mainResearchTeamDiv {
  text-align: left;
  margin-top: 40%;
}

.researchTeamDiv {
  background: white;
  border-radius: 12px;
  width: 88%;
  color: black;
  height: 400px;
}

.membersDiv {
  position: absolute;
  top: 50%;
  left: 50%;
  height: 90%;
  width: 90%;
  font-size: 14px;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  background: #ffffff;
  border-radius: 12px;
}

.membersInnerDiv {
  color: #000000;
  height: 85%;
}

.membersHeader {
  background-color: #e4e8eb;
  border-radius: 12px 12px 0 0;
}

.membersList {
  overflow-y: scroll;
  height: 83%;
  border-bottom: none;
  padding-top: 10px;
  margin-right: 5px;
}

.membersList::-webkit-scrollbar {
  width: 7px;
}

.membersList::-webkit-scrollbar-thumb {
  background: #c4c4c4;
  border-radius: 5px;
}

.videoDiv {
  text-align: center;
}

.team-btn {
  background-color: #9b9b9b;
  color: #ffffff;
  width: 80%;
  border-radius: 12px;
  margin-top: 65%;
  padding-left: 22px;
}

.call-btn {
  background-color: #2ecc71;
  color: #ffffff;
  width: 80%;
  border-radius: 12px;
}

.plusDiv {
  color: #2f80ed;
  background-color: #f2f2f2;
  height: 22px;
  width: 22px;
  float: left;
  border-radius: 3px;
  font-weight: bold;
}
</style>
